var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datasets)?_c('div',{staticClass:"sidebar-sparkline"},[_c('canvas',{staticClass:"chart",attrs:{"id":_vm.id,"height":_vm.height,"width":_vm.width}}),_vm._v(" "),_c('div',{staticClass:"hover-cta"},[_c('v-btn',{on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("View more...")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b8108d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarSparkline.vue
// module id = AHST
// module chunks = 1